import moment from 'moment';
import IntAssessHdrService from "@/service/IntAssessHdrService";
import SweetAlertService from "@/service/SweetAlertService";
import LeaveTypeService from "@/service/LeaveTypeService";
import StoreGetter from "@/constants/StoreGetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Vue from 'vue';
import { SchedulePlugin, Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop } from '@syncfusion/ej2-vue-schedule';
import Settings from '../../constants/Settings';
Vue.use(SchedulePlugin);
export default {
  name: "Calendar",
  mounted() {
    this.getAllCalendarData();
    this.getLeaveType();
  },
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop]
  },
  data: () => ({
    e1: 1,
    isLoaded: false,
    Settings: Settings,
    dictEnum: dictEnum,
    selectedDate: new Date(),
    eventSettings: {
      allowDeleting: false,
      allowAdding: false,
      allowEditing: false,
      dataSource: []
    },
    HintList: [
      {
        id: "LeaveAppNotAppro",
        color: "#ff7f27",
        value: `${t.t(dictEnum.MENU_LeaveApp)}(${t.t(dictEnum.LBL_NotApprove)})`
      },
      {
        id: "Interview",
        color: "#0fb8cb",
        value: t.t(dictEnum.LBL_Interview)
      }
    ],
    leaveTypeList: []
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    async getLeaveType() {
      const response = await LeaveTypeService.getLeaveTypes();
      const user = this.$store.getters[StoreGetter.user];
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.leaveTypeList = response.data.Data
        response.data.Data.forEach(x => {
          let data = {
            id: x.LeaveType,
            color: x.Color,
            value: user.Lang == "EN" ? x.EDesc : x.CDesc
          };
          this.HintList.push(data)
        })
      }
    },
    async getAllCalendarData() {
      var self = this;
      const obj = {};
      const response = await IntAssessHdrService.getAllCalendarData(obj);
      if (response.data.IsSuccess) {
        response.data.Data = response.data.Data.filter((x) =>
          x.Approved == ""
          || x.Approved == null
          || x.Approved == Settings.LeaveStatus.Approved
          || x.Approved == Settings.LeaveStatus.CancelLeavePending
          || x.Approved == Settings.LeaveStatus.CancelledLeaveRejected)
        self.eventSettings.dataSource = response.data.Data;
        if (self.eventSettings.dataSource != null && self.eventSettings.dataSource.length > 0) {
          self.eventSettings.dataSource.forEach(
            (element) => {
              if (this.needUploadFile(element)) {
                element.Subject = `${element.Subject} (${this.getDocStatus(element)})`
              }
              if (element.StartTime != null && element.StartTime != "") {
                var startTime = new Date(parseInt(moment(element.StartTime).format("YYYY")), parseInt(moment(element.StartTime).format("MM")) - 1, parseInt(moment(element.StartTime).format("DD")), parseInt(moment(element.StartTime).format("HH")), parseInt(moment(element.StartTime).format("mm")));
                element.StartTime = startTime;
              }
              if (element.EndTime != null && element.EndTime != "") {
                var endTime = new Date(parseInt(moment(element.EndTime).format("YYYY")), parseInt(moment(element.EndTime).format("MM")) - 1, parseInt(moment(element.EndTime).format("DD")), parseInt(moment(element.EndTime).format("HH")), parseInt(moment(element.EndTime).format("mm")));
                element.EndTime = endTime;
              }
            });
        }
        self.isLoaded = true;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    needUploadFile(item) {
      const find = this.leaveTypeList.find(x => x.LeaveType == item.LeaveType);
      if (find && item.HaveAttachments && item.Type == 'Leave') {
        return find.IsNeedUpload;
      } else {
        return false;
      }
    },

    getDocStatus(item) {
      if (item.DocStatus == null || item.DocStatus == "")
        return t.t(dictEnum.LBL_Pending);
      if (item.DocStatus == Setting.LeaveStatus.Approved)
        return t.t(dictEnum.LBL_Approved);
      if (item.DocStatus == Setting.LeaveStatus.Rejected)
        return t.t(dictEnum.LBL_Rejected);
    },
    onPopupOpen: function (args) {
      // Create required custom elements in initial time
      var buttonElement = (args.type === "QuickInfo") ? ".e-event-popup .e-delete" : ".e-schedule-dialog .e-event-delete";
      var editElement = (args.type === "QuickInfo") ? ".e-event-popup .e-edit" : ".e-schedule-dialog .e-event-edit";
      //var closeElement = (args.type === "QuickInfo") ? ".e-event-popup .e-close" : ".e-schedule-dialog .e-event-close";
      var deleteButton = document.querySelector(buttonElement);
      var editButton = document.querySelector(editElement);
      //var closeButton = document.querySelector(closeElement);
      if (deleteButton != null && editButton != null) {
        deleteButton.ej2_instances[0].cssClass = "d-none";
        editButton.ej2_instances[0].cssClass = "d-none";
        //closeButton.ej2_instances[0].cssClass = "d-none";
      }
    },
    oneventRendered: function (args) {
      let scheduleObj = this.$refs.ScheduleObj;
      let categoryColor = args.data.CategoryColor;
      if (!args.element || !categoryColor) {
        return;
      }
      if (scheduleObj.ej2Instances.currentView === 'Agenda') {
        (args.element.firstChild).style.borderLeftColor = categoryColor;
      } else {
        args.element.style.backgroundColor = categoryColor;
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S100000-Calendar/S100000-Calendar.js